import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { tenantQueryOptions } from '@/shared/auth/session'

import { buildPaletteCss } from './palette'

export const PALETTE_STYLE_ID = 'tenant-palette'
export const PALETTE_STORAGE_KEY = 'appx-hub:palette'

/** Guarda o CSS para o `index.html` aplicá-lo antes do bundle (sem piscar a paleta padrão). */
function remember(css: string) {
  try {
    if (css) window.localStorage.setItem(PALETTE_STORAGE_KEY, css)
    else window.localStorage.removeItem(PALETTE_STORAGE_KEY)
  } catch {
    // Armazenamento indisponível: só perde o anti-flash.
  }
}

/**
 * Aplica a paleta do tenant (cores-base da marca) sobre os tokens do `index.css`.
 * Não renderiza nada; lê o endpoint público, então vale também nas telas de login.
 */
export function TenantPalette() {
  const { data: tenant } = useQuery(tenantQueryOptions)
  const branding = tenant?.branding
  const primary = branding?.primary_color
  const primaryDark = branding?.primary_color_dark
  const sidebar = branding?.sidebar_color
  const loaded = branding !== undefined

  useEffect(() => {
    // Enquanto o tenant carrega, mantém o que o `index.html` aplicou do cache.
    if (!loaded) return

    const css = buildPaletteCss({ primary, primaryDark, sidebar })
    let style = document.getElementById(PALETTE_STYLE_ID)

    if (!css) {
      style?.remove()
    } else {
      if (!style) {
        style = document.createElement('style')
        style.id = PALETTE_STYLE_ID
        document.head.appendChild(style)
      }
      style.textContent = css
    }

    remember(css)
  }, [loaded, primary, primaryDark, sidebar])

  return null
}
